import { Service, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProjectDataService } from '@data-services/projects';
import { ErrorHandlingService } from '@errors/error-handling.service';
import { DataContext } from '@services/data-context';

@Service()
export class ProjectAccessService {
  private readonly dataContext = inject(DataContext);
  private readonly projectDataService = inject(ProjectDataService);
  private readonly errorHandler = inject(ErrorHandlingService);
  private readonly translate = inject(TranslateService);

  async loadProjectDetailsAsync(projectId: string): Promise<void> {
    try {
      const project = await this.projectDataService.getProjectAsync(projectId);
      this.dataContext.completeProjectContext(project);
    } catch (error: unknown) {
      await this.errorHandler.handleErrorAsync(error, this.translate.instant('general.loadProjectError')).catch(() => undefined);
    }
  }

  async loadCompanyAccessAsync(projectId: string): Promise<void> {
    try {
      const response = await this.projectDataService.getIsAnyCompanyUserAsync(projectId);
      this.dataContext.setClientAccess(projectId, response.isAnyCompanyUser);
    } catch (error: unknown) {
      await this.errorHandler.handleErrorAsync(error, this.translate.instant('general.loadProjectError')).catch(() => undefined);
    }
  }
}
